<template>
    <!--
      作者：kmdshop
      时间：2019-10-25
      描述：订单列表
  -->
    <div class="user">
        <!--搜索表单-->
        <div class="common-seach-wrap">
            <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
                <el-form-item label="订单号"><el-input size="small" v-model="searchForm.order_sn"
                        placeholder="请输入订单号"></el-input></el-form-item>
                <el-form-item label="产品名称"><el-input size="small" v-model="searchForm.product_name"
                        placeholder="请输入产品名称"></el-input></el-form-item>
                <el-form-item label="配送方式">
                    <el-select size="small" v-model="searchForm.shipping_type" placeholder="请选择">
                        <el-option label="全部" value=""></el-option>
                        <el-option v-for="(item, index) in exStyle" :key="index" :label="item.name"
                            :value="item.shipping_type"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="门店列表">
                    <el-select size="small" v-model="searchForm.store_id" placeholder="请选择">
                        <el-option label="全部" value=""></el-option>
                        <el-option v-for="(item, index) in shopList" :key="index" :label="item.store_name"
                            :value="item.store_id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="供应商列表">
                    <el-select size="small" v-model="searchForm.supply_id" placeholder="请选择">
                        <el-option label="全部" value=""></el-option>
                        <el-option v-for="(item, index) in supplyList" :key="index" :label="item.name"
                            :value="item.supply_id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="物流中心" v-if="is_open_logistics">
                    <el-select size="small" v-model="searchForm.logistics_id" placeholder="请选择">
                        <el-option label="全部" value=""></el-option>
                        <el-option v-for="(item, index) in logisticsList" :key="index" :label="item.name"
                            :value="item.logistics_id"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="起止时间">
                    <div class="block">
                        <span class="demonstration"></span>
                        <el-date-picker size="small" v-model="searchForm.create_time" type="daterange"
                            value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期"
                            end-placeholder="结束日期"></el-date-picker>
                    </div>
                </el-form-item>
               <!-- <el-form-item label="导出方式">
                    <el-select size="small" v-model="searchForm.export_type" placeholder="请选择">
                        <el-option label="按订单" value=""></el-option>
                        <el-option label="按产品" value="1"></el-option>
                    </el-select>
                </el-form-item> -->
               <!-- <el-form-item style="float: right;">
                    <el-button size="small" type="warning" @click="showBatchDelivery"
                        v-auth="'/order/order/operate/batchDelivery'">批量发货</el-button>
                </el-form-item> -->

                <el-form-item><el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button></el-form-item>
                <el-form-item><el-button size="small" type="success" @click="onExport">导出</el-button></el-form-item>
                <!-- <el-form-item><el-button size="small" type="primary" @click="importOrder"
                        v-auth="'/order/order/operate/import'">导入</el-button></el-form-item> -->
            </el-form>
        </div>
        <!--内容-->
        <div class="product-content">
            <div class="table-wrap">
                 <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane :label="item.name+'('+item.total+')'" :name="item.status" :key="index"
                        v-for="item,index in cates"></el-tab-pane>
                </el-tabs>
                <!-- 表格内容 -->
                <el-table size="small" :data="tableData.data" border style="width: 100%" v-loading="loading"
                    :tree-props="{ children: 'children', hasChildren: (row) => row.children && row.children.length > 0 }"
                    :row-key="getRowKey" :row-class-name="tableRowClassName" default-expand-all>
                    <el-table-column prop="order_no" label="订单信息" width="100">
                        <template slot-scope="{ row }">
                                <div class="order-code">
                                    <span class="c_main hand" @click="handleCopy(row.order_sn, $event)">
                                        订单号：{{ row.order_sn }}
                                    </span>
                                    <span class="pl16">下单时间：{{ row.create_time }}</span>
                                </div>                 
                        </template>
                    </el-table-column>
                    <el-table-column prop="total_price" label="产品"  width="300">
                        <template  slot-scope="{ row }">
                                <div class="product-info"
                                
                                v-for="(item, index) in row.horderProducts" :key="index" 
                                 >
                                    <div class="pic"><img v-img-url="item.image?item.image:''" alt="" /></div>
                                    <div class="info">
                                        <div class="name gray3 product-name">
                                        <span>{{ item.name }}</span>
                                        </div>
                                        <div  >
                                            <div class="orange">￥ {{ item.product_price }}</div>
                                            <div class="gray3">x{{ item.num }}</div>
                                        </div>
                                    </div>
                                    
                            </div>
                            </template>

                    </el-table-column>

                    <el-table-column prop="total_price" label="订单总价">
                    </el-table-column>
              
                    <el-table-column prop="total_pay_price" label="实付款">
                    </el-table-column>
                    <el-table-column prop="express_price" label="运费">
                    </el-table-column>
                    <el-table-column prop="discount_price" label="满减">
                    </el-table-column>
                    <el-table-column prop="num" width="50" label="产品数量">
                    </el-table-column>
                    <el-table-column prop="status" label="订单状态">
                        <template slot-scope="scope" v-if="scope.row.horder_id">
                            {{scope.row.status == 0?'已创建' : scope.row.status == 20?'待审核' :scope.row.status == 30?'审核通过' :scope.row.status == 40?'审核拒绝' :scope.row.status == 50?'待付款' :scope.row.status == 60?'已付款' :scope.row.status == 70?'生产中' :scope.row.status == 80?'已发货' :scope.row.status == 90?'已完成' : '已取消'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="pay_status" label="付款状态">
                        <template slot-scope="scope" v-if="scope.row.horder_id && !scope.row.horder_product_id" >
                            {{ scope.row.pay_status == 1?'已支付' : '未支付' }}
                        </template>
                    </el-table-column>

                    <el-table-column prop="supply.name" label="供应商">
                    </el-table-column>
                    <el-table-column prop="" label="生产期限">
                        <template slot-scope="scope">
                            {{timestampToTime(scope.row.production_deadline)}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="accept_time" label="接单时间">
                        <template slot-scope="scope">
                            {{timestampToTime(scope.row.accept_time)}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="cancel_time" label="取消时间">
                        <template slot-scope="scope">
                            {{timestampToTime(scope.row.cancel_time)}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="completion_time" label="完成时间">
                        <template slot-scope="scope">
                            {{timestampToTime(scope.row.completion_time)}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="audit_remark" label="备注">

                    </el-table-column>
                    <!-- <el-table-column prop="logistics" label="送货地址" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.logistics">{{ scope.row.logistics.name }}({{ scope.row.logistics.logistics_id }})</span>
              <span v-else>平台</span>
            </template>
          </el-table-column> -->
                    <el-table-column fixed="right" label="操作" width="130">
                        <template slot-scope="scope" v-if="scope.row.horder_id">

                            <el-button @click="payClick(scope.row)" 
                            v-if="scope.row.pay_status == 0 && scope.row.is_can_pay == 1" type="text" size="small"
                           >付款</el-button>

                           <el-button 
                           @click="subExpress(scope.row)"
                           v-if="scope.row.status == 70" 
                           type="text" 
                           size="small"
                           style="color: #67C23A">发货</el-button>
 
                            <el-button @click="addClick(scope.row)" v-if="!scope.row.horder_product_id" type="text" size="small"
                                v-auth="'/plus/horder/index/detail'">订单详情</el-button>
                            <el-button v-if="scope.row.status == 20" @click="passorder(scope.row)"
                                type="text" size="small" v-auth="'/plus/horder/index/detail'">审核通过</el-button>
                            <el-button v-if="scope.row.status == 20" @click="refuseorder(scope.row)"
                                type="text" size="small" v-auth="'/plus/horder/index/detail'">审核拒绝</el-button>
                                
                            <!-- <el-button v-if="role == 2 && (scope.row.status < 60 || scope.row.status == 100) && !scope.row.horder_product_id" @click="delOrder(scope.row)"
                                type="text" size="small" v-auth="'/plus/horder/index/detail'">删除订单</el-button> -->
                                
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <!--分页-->
            <div class="pagination">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
                    :current-page="curPage" :page-size="pageSize" layout="total, prev, pager, next, jumper"
                    :total="totalDataNumber"></el-pagination>
            </div>
        </div>

        <el-dialog title="批量发货说明" :visible.sync="dialogBatchDelivery" width="30%">
            <div>1、先按未发货条件筛选后，导出订单</div>
            <div>2、在导出excel中填写物流公司、物流单号，然后点批量发货导入填好的excel文件</div>
            <div>3、请检查物流公司是否已经添加到系统，<el-link type="primary" :underline="false" @click="gotoExpress()">查看</el-link>
            </div>
            <div style="padding-top: 20px;padding-bottom: 20px;text-align: center;">
                <el-upload class="avatar-uploader" ref="upload" action="string"
                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    :before-upload="onBeforeUploadImage" :http-request="uploadImage" :show-file-list="false">
                    <el-button size="small" icon="el-icon-upload" type="primary">上传发货表格</el-button>
                </el-upload>
            </div>
        </el-dialog>

        <!-- 上传导入组件  -->
        <Upload v-if="open_upload" @closeDialog="closeDialogFunc($event,'upload')"></Upload>

    </div>
</template>

<script>
    import HorderApi from '@/api/horder.js'
    import Upload from '@/components/file/import'
    import qs from 'qs'
    import clip from '@/utils/clipboard'
    export default {
        components: {
            Upload
        },
        data() {
            return {
                rowKey: 1,
                /*切换菜单*/
                activeName: "",
                /*是否加载完成*/
                loading: true,
                /*列表数据*/
                tableData: [],
                /*一页多少条*/
                pageSize: 20,
                /*一共多少条数据*/
                totalDataNumber: 0,
                /*当前是第几页*/
                curPage: 1,
                /*横向表单数据模型*/
                searchForm: {
                    product_name: "",
                    shipping_type: '',
                    order_sn: '',
                    style_id: '',
                    store_id: '',
                    create_time: '',
                    supply_id:""
                },
                /*配送方式*/
                exStyle: [],
                /*门店列表*/
                shopList: [],
                // 供应商列表
                supplyList:[],
                /* 物流中心 */
                logisticsList: [],
                /* 是否开启物流中心 */
                is_open_logistics: false,
                /*时间*/
                create_time: '',
                /*统计*/
                order_count: {
                    payment: 0,
                    delivery: 0,
                    received: 0
                },
                supply_id: 0,
                supply: {},
                open_upload: false,
                // 导入类型
                import_type: 'order',
                dialogBatchDelivery: false,
                // 订单状态
                status: 0,
                cates: [],
                role: ""
            };
        },
        created() {
            // 获取筛选列表
            this.getList()
            /*获取列表*/
            this.getData();
        },
        methods: {
            payClick(row){
                var self = this;
                self.$router.push({
                    path: '/store/placeorder/order',
                    query: {
                        order_id: row.horder_id
                    }
                })     
            },
            // 筛选列表
            getList(){
                let that = this
                HorderApi.sceenList({},true).then((res) => {
                    console.log("sceenitem",res)
                    if(res.code == 1){
                        that.exStyle = res.data.shipping_type_list
                        that.shopList = res.data.store_list
                        that.supplyList = res.data.supply_list
                    }
                })
            },
            // 删除订单
            delOrder(e){
                let that = this
                let data = {}
                data.horder_id = e.horder_id
                HorderApi.delOrder(data, true).then(res => {
                    if (res.code == 1) {
                        console.log(res)
                        if (res.code == 1) {
                            this.$message({
                                message: res.msg,
                                type: 'success'
                            });
                            setTimeout(() => {
                                that.getData()
                            }, 1000)
                        }
                
                    }
                })
                 
            },
            // 动态生成唯一 row-key
            getRowKey(row) {
                // 按层级生成唯一键
                return row.horder_id ?
                    `order_${row.horder_id}` :
                    row.supply_id ?
                    `supply_${row.supply_id}` :
                    `product_${row.horder_product_id}`;
            },

            subExpress(row) {
                let self = this;
                let params = row.horder_product_id?row.horder_product_id : row.horder_id
                let type = row.horder_product_id?2:1
                self.$router.push({
                    path: '/plus/horder/index/detail',
                    query: {
                        order_id: params,
                        role: self.role,
                        type:type
                    }
                });
                // console.log(data); 
                // let that = this
                // HorderApi.deliverGoods( data, true).then((res) => {
                //     if (res.code == 1) {
                //         that.$message({
                //             message: res.msg,
                //             type: 'success'
                //         });
                      
                //     }
                // })
            },
            // 添加层级样式区分
            tableRowClassName({
                row
            }) {
                if (row.supply_id) return 'supplier-row'
                if (row.horder_product_id) return 'product-row'
            },
            /*跨多列*/
            arraySpanMethod(row) {
                if (row.rowIndex % 2 == 0) {
                    if (row.columnIndex === 0) {
                        return [1, 8];
                    }
                }
            },
            // 取消订单
            cancelOrder(item) {
                let that = this

            },

            /*选择第几页*/
            handleCurrentChange(val) {
                let self = this;
                self.curPage = val;
                self.getData();
            },

            /*每页多少条*/
            handleSizeChange(val) {
                this.curPage = 1;
                this.pageSize = val;
                this.getData();
            },

            /*切换菜单*/
            handleClick(tab, event) {
                let self = this;
                console.log("tab", tab)
                console.log("event", event)
                console.log(self.activeName)
                self.curPage = 1;
                self.getData();
            },
            // 订单审核通过
           passorder(item) {
    let self = this;
    let datas = {};
    let array = [];
    console.log('item',item);
    

    // 情况1：单个产品（直接提交）
    if (item.horder_product_id) {
        let tep = {
            horder_product_id: item.horder_product_id,
            status: 30,
        };
        array.push(tep);
    }
    // 情况2：父级订单（遍历子产品）
    else if (item.children && item.children.length > 0 && item.children[0].children) {
        item.children[0].children.forEach((v) => {
            let te = {
                horder_product_id: v.horder_product_id,
                status: 30,
            };
            array.push(te);
        });
    }
    // 情况3：数据异常（报错提示）
    else {
        // this.$message.error("订单数据异常，无法审核");
        // return;
         item.horderProducts.forEach((v) => {
            let te = {
                horder_product_id: v.horder_product_id,
                status: 30,
            };
            array.push(te);
        });
       
    }

    datas.params = array;
    HorderApi.passorder(datas, true).then((res) => {
        if (res.code == 1) {
            this.$message({
                message: res.msg,
                type: "success",
            });
            setTimeout(() => {
                self.getData();
            }, 1000);
        }
    });
},
            // 时间戳转时间方法
            timestampToTime(timestamp) {
                if (timestamp) {
                    var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
                    var Y = date.getFullYear() + '-';
                    var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
                    var D = date.getDate() + ' ';
                    var h = date.getHours() + ':';
                    var m = date.getMinutes() + ':';
                    var s = date.getSeconds();
                    return Y + M + D + h + m + s;
                } else {
                    return "-"
                }

            },

            // 订单审核不通过
            async refuseorder(item) {
                var self = this;
                const reject_val = await self.promptInput('请输入不通过的原因',
                    '请输入不通过的原因');
                console.log(reject_val)
                var self = this
                let datas = {}
                let array = []
                if(item.horder_product_id){
                    let tep = {}
                    tep.horder_product_id = item.horder_product_id
                    tep.status = 40
                    tep.audit_remark = reject_val
                    array.push(tep)
                }else{
                    console.log(item)
                    item.children[0].children.forEach((v,i) => {
                        let te = {}
                        te.status = 40
                        te.horder_product_id = v.horder_product_id
                        te.audit_remark = reject_val
                        array.push(te)
                    })
                }
                datas.params = array
                HorderApi.passorder(datas, true).then(res => {
                    if (res.code == 1) {
                        console.log(res)
                        if (res.code == 1) {
                            this.$message({
                                message: res.msg,
                                type: 'success'
                            });
                            setTimeout(() => {
                                self.getData()
                            }, 1000)
                        }
                
                    }
                })
            },
            async promptInput(message, validation) {
                try {
                    const {
                        value
                    } = await this.$prompt(message, '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        inputErrorMessage: validation,
                    });
                    return value.trim();
                } catch (e) {
                    this.$message({
                        type: 'info',
                        message: '取消输入',
                    });
                }
            },
            /*获取列表*/
            getData() {
                let self = this;
                let Params = this.searchForm;
                Params.start_time = Params.create_time[0]
                Params.end_time = Params.create_time[1]
                Params.status = self.activeName == 0 ? '' : self.activeName == 1 ? 0 : self.activeName;
                Params.page = self.curPage;
                Params.list_rows = self.pageSize;

                const status = this.$route.query.status; 
                if(status){
                    Params.status = status
                }

                self.loading = true;
                HorderApi.list(Params, true)
                    .then(res => {
                        console.log(res)
                        self.loading = false;
                        let list = []
                        self.cates = res.data.count
                        console.log('res.data.data', res.data.data);
                        self.tableData.data = res.data.data;
                        self.role = res.data.role
                        console.log("self", self.tableData)
                    })
                    .catch(error => {});
            },

            /*打开添加*/
            addClick(row) {
                let self = this;
                let params = row.horder_product_id?row.horder_product_id : row.horder_id
                let type = row.horder_product_id?2:1
                self.$router.push({
                    path: '/plus/horder/index/detail',
                    query: {
                        order_id: params,
                        role: self.role,
                        type:type
                    }
                });
            },

            /*搜索查询*/
            onSubmit() {
                this.curPage = 1;
                this.tableData = [];
                this.getData();
            },
            onExport: function() {
                let baseUrl = window.location.protocol + '//' + window.location.host;
                window.location.href = baseUrl + '/index.php/shop/plus.horder.Index/export?' + qs.stringify(this
                    .searchForm);
            },
            // 商品导入
            importOrder: function(row) {
                this.open_upload = true
            },
            /*关闭弹窗*/
            closeDialogFunc(e, f) {
                if (f == 'upload') {
                    this.open_upload = e.openDialog;
                    if (e.type == 'success') {
                        this.getData();
                    }
                }
            },
            // 显示批量发货说明
            showBatchDelivery() {
                this.dialogBatchDelivery = true;
            },
            /*跳转物流公司*/
            gotoExpress() {
                let self = this;
                self.$router.push('/setting/express/index');
            },

            /*选择图片之前*/
            onBeforeUploadImage(file) {
                var fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
                const isEXCEL = fileType === 'xlsx';
                const isLt10M = file.size / 1024 / 1024 < 10;
                if (!isEXCEL) {
                    this.$message.error('上传文件只能是excel格式!');
                }
                if (!isLt10M) {
                    this.$message.error('上传文件大小不能超过 10MB!');
                }
                return isEXCEL && isLt10M;
            },

            /*上传图片*/
            uploadImage(param) {
                let self = this;
                const loading = this.$loading({
                    lock: true,
                    text: '正在处理,请等待',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                let formData = new FormData();
                formData.append('iFile', param.file);
                OrderApi.batchDelivery(formData)
                    .then(response => {
                        loading.close();
                        self.dialogBatchDelivery = false;
                        self.$message({
                            message: response.msg,
                            type: 'warning'
                        });
                    })
                    .catch(response => {
                        loading.close();
                        self.$message({
                            message: '本次处理失败',
                            type: 'warning'
                        });
                        param.onError();
                    });
            },

            handleCopy(text, event) {
                clip(text, event)
            },

        }
    };
</script>
<style lang="scss" scoped>

      .product-info {
        padding: 10px 0;
        border-top: 1px solid #eeeeee;
        }
        .order-code .state-text {
        padding: 2px 4px;
        border-radius: 4px;
        background: #808080;
        color: #ffffff;
        }
        .order-code .state-text-red{ background: red;}
        .table-wrap .product-info:first-of-type {
        border-top: none;
        }
        .table-wrap .el-table__body tbody .el-table__row:nth-child(odd) {
        background: #f5f7fa;
        }

    

</style>


// WEBPACK FOOTER //
// src/views/plus/horder/index/index.vue